<template>
    <table class="egrul-records-table">
        <thead>
            <tr>
                <th>Дата</th>
                <th>ГРН</th>
                <th>Вид изменения</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(r, i) in records" :key="i">
                <td>{{ r.grn_date }}</td>
                <td>{{ r.grn }}</td>
                <td>{{ r.type }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        records: Array
    }
}
</script>

<style lang="sass" scoped>
    .egrul-records-table
        font-size: 13px
        td, th
            padding: 8px
            vertical-align: top
            text-align: left
        th
            font-weight: 700
</style>